export default "__VITE_ASSET__ByyMSu$m__"